import apiFetch from '../apiFetch'

export default function (token, organizedUnitId, validationTypeCode, paramsToValidate) {
  return apiFetch({ endPoint: `Validate/${validationTypeCode}/${organizedUnitId}`, method: 'POST', token: token, body: paramsToValidate })
}
